import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullCalendarModule } from 'ng-fullcalendar';

import { AtxCalendarComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
        FullCalendarModule,
    ],
    declarations: [
        AtxCalendarComponent,
    ],
    exports: [
        AtxCalendarComponent,
    ],
})

export class AtxCalendarModule {}
